module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/icon-exchange-4d95d2fe808321b1253a719265dc1c2c.png";